<form class="milestone-entry-body" [formGroup]="data.fg">
  <div class="row">
    <div class="milestone-entry-category">
      <mat-icon *ngIf="data.ms.category && data.ms.customRef"
                matTooltip="{{ categoryLabel }}"
                svgIcon="{{ categoryIcon }}"
      ></mat-icon>
    </div>
    <div class="milestone-entry-ref">
      {{ data.ms.customRef }}
    </div>
  </div>
  <mat-form-field class="milestone-entry-name-input">
    <mat-label>{{ placeholder }}</mat-label>
    <label>
      <input matInput type="text" readonly value="{{ data.ms.name }}" matTooltip="{{ data.ms.name }}" />
    </label>
  </mat-form-field>
  <mat-icon
    class="tooltip-icon"
    svgIcon="tooltip"
    matTooltipPosition="right"
    matTooltip="{{ cachedSummary }}"
  ></mat-icon>

  <div
    *ngIf="!data.ms.constructionTemplate.isSingleMilestone"
    class="milestone-at-fid-block milestone-at-fid-block-constr"
  >
    <div class="milestone-date-and-checkbox">
      <mat-form-field class="milestone-entry-fid-input">
        <mat-label>&#64;FID - Start Date</mat-label>
        <label>
          <input
            matInput
            type="date"
            formControlName="dateFidStart"
            [readonly]="readOnly || !canEditFid"
            [ngClass]="{
              changed:
                !data.ms.synthetic &&
                !data.fg.getRawValue().notApplicable &&
                data.initial.dateFidStart !== data.fg.getRawValue().dateFidStart,
            }"
          />
        </label>
        <mat-error *ngIf="data.fg.get('dateFidStart')?.invalid">
          {{ ValidatorUtil.getErrorMessage(data.fg.get('dateFidStart')) }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="milestone-date-and-checkbox">
      <mat-form-field class="milestone-entry-date-input">
        <mat-label>Current - Start Date</mat-label>
        <label>
          <input
            matInput
            type="date"
            formControlName="dateStart"
            [required]="data.mandatory"
            [readonly]="
              readOnly ||
              data.fg.getRawValue().notApplicable ||
              data.fg.getRawValue().started ||
              (!projectCreation && (data.ms.keyDataChange === 'cod' || data.ms.keyDataChange === 'fid'))
            "
            [ngClass]="{
              changed:
                !data.ms.synthetic &&
                !data.fg.getRawValue().notApplicable &&
                data.initial.dateStart !== data.fg.getRawValue().dateStart,
            }"
            (click)="onDateInputClicked($event)"
          />
        </label>
        <mat-error *ngIf="data.fg.get('dateStart')?.invalid">
          {{ ValidatorUtil.getErrorMessage(data.fg.get('dateStart')) }}
        </mat-error>
      </mat-form-field>
      <mat-icon
        *ngIf="isStartDateInPast()"
        class="warning-triangle"
        matTooltip="PLAUSIBILITY WARNING: Please check this date as it is an uncompleted date in the past.
            If this has now been completed place a tick in the Complete box otherwise re-forecast the date into
            the future."
      >
        warning
      </mat-icon>
      <mat-icon
        *ngIf="isStartDateInFuture()"
        class="warning-triangle"
        matTooltip="PLAUSIBILITY WARNING: Please check this date as it is a completed date in the future.
            If this has not yet been completed remove the tick from the Complete box otherwise change the date to
            when the milestone was completed in the past."
      >
        warning
      </mat-icon>
      <mat-icon *ngIf="!isStartDateInPast() && !isStartDateInFuture()" class="warning-triangle transparent">
        warning
      </mat-icon>

      <digires-checkbox
        [formGroup]="data.fg"
        formCtrlName="started"
        [disabled]="
          readOnly ||
          data.fg.getRawValue().notApplicable ||
          data.fg.getRawValue().complete ||
          !data.fg.getRawValue().dateStart
        "
        tooltip="Started"
        [cssClasses]="{
          changed:
            !data.ms.synthetic &&
            !data.fg.getRawValue().notApplicable &&
            data.initial.started !== data.fg.getRawValue().started,
        }"
      ></digires-checkbox>
    </div>
  </div>

  <div class="milestone-at-fid-block">
    <div class="milestone-date-and-checkbox">
      <mat-form-field class="milestone-entry-fid-input">
        <mat-label>{{ getFidDatePlaceholder() }}</mat-label>
        <label>
          <input
            matInput
            type="date"
            formControlName="dateFid"
            [readonly]="readOnly || !canEditFid"
            [ngClass]="{
              changed:
                !data.ms.synthetic &&
                !data.fg.getRawValue().notApplicable &&
                data.initial.dateFid !== data.fg.getRawValue().dateFid,
            }"
          />
        </label>
        <mat-error *ngIf="data.fg.get('dateFid')?.invalid">
          {{ ValidatorUtil.getErrorMessage(data.fg.get('dateFid')) }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="milestone-date-and-checkbox">
      <mat-form-field class="milestone-entry-date-input">
        <mat-label>{{ getDatePlaceholder() }}</mat-label>
        <label>
          <input
            matInput
            type="date"
            formControlName="date"
            required
            [readonly]="
              readOnly ||
              data.fg.getRawValue().notApplicable ||
              data.fg.getRawValue().complete ||
              (!projectCreation && (data.ms.keyDataChange === 'cod' || data.ms.keyDataChange === 'fid'))
            "
            [ngClass]="{
              changed:
                !data.ms.synthetic &&
                !data.fg.getRawValue().notApplicable &&
                data.initial.date !== data.fg.getRawValue().date,
            }"
            (click)="onDateInputClicked($event)"
          />
        </label>
        <mat-error *ngIf="data.fg.get('date')?.invalid">
          {{ ValidatorUtil.getErrorMessage(data.fg.get('date')) }}
        </mat-error>
      </mat-form-field>
      <mat-icon
        *ngIf="isEndDateInPast()"
        class="warning-triangle"
        matTooltip="PLAUSIBILITY WARNING: Please check this date as it is an uncompleted date in the past.
              If this has now been completed place a tick in the Complete box otherwise re-forecast the date into
              the future."
      >
        warning
      </mat-icon>
      <mat-icon
        *ngIf="isEndDateInFuture()"
        class="warning-triangle"
        matTooltip="PLAUSIBILITY WARNING: Please check this date as it is a completed date in the future.
              If this has not yet been completed remove the tick from the Complete box otherwise change the date
              to when the milestone was completed in the past."
      >
        warning
      </mat-icon>
      <mat-icon *ngIf="!isEndDateInPast() && !isEndDateInFuture()" class="warning-triangle transparent">
        warning
      </mat-icon>

      <digires-checkbox
        [formGroup]="data.fg"
        formCtrlName="complete"
        [disabled]="readOnly || data.fg.getRawValue().notApplicable || !data.fg.getRawValue().date"
        tooltip="Completed"
        labelPosition="after"
        [cssClasses]="{
          changed:
            !data.ms.synthetic &&
            !data.fg.getRawValue().notApplicable &&
            data.initial.complete !== data.fg.getRawValue().complete,
        }"
        (onChange)="onCompleteChanged()"
      ></digires-checkbox>
    </div>
  </div>
</form>
